import { render, staticRenderFns } from "./usergroup-renewal-orders.vue?vue&type=template&id=5bf823a6&scoped=true"
import script from "./usergroup-renewal-orders.vue?vue&type=script&lang=js"
export * from "./usergroup-renewal-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf823a6",
  null
  
)

export default component.exports